
const lib = (letter: string) => `([${letter.toLowerCase()}${letter.toUpperCase()}])`;
const eyes = '[;:]';
const nose = '[^-o]?';
const mouthHappy = '[)£}]';
const mouthSad = '[(€{]';
const mouthOh = '[Oo0]';
const emoticons = {
    'classic-smiley': [eyes + nose + mouthHappy],
    'cute-derp': [eyes + nose + '!'],
    'classic-smiley-eyebrows': ['|' + eyes + nose + mouthHappy],
    'cute-sad-face': [eyes + nose + mouthSad],
    'classic-sad-face': [eyes + nose + '[Cc]'],
    'sad-face-tear': [eyes + '_' + mouthSad],

    'wide-smile': [eyes + nose + 'D'],
    'wide-smile-closed-eyes-1': ['[xX]' + nose + 'D'],
    'wide-smile-closed-eyes-2': ['3' + nose + 'D'],

    'angry-face': ['>' + eyes + nose + mouthSad],
    'sad-face-closed-eyes-1': ['D' + nose + '[Xx]'],
    'sad-face-closed-eyes-2': ['D' + nose + eyes],

    'cool-steve': ['8' + nose + ')'],
    'cool-steve-wide-smile': ['8' + nose + 'D'],
    'wide-smile-heart-eyes': ['<3' + nose + 'D'],

    'thinking': [eyes + nose + '[/]'],
    'closed-eyes-derp': ['[Xx]' + nose + '[Pp]'],
    'dissapointed-face': [eyes + nose + '3', eyes + nose + '$'],

    'laugh-cry': [eyes + '_D'],
    'angel': [lib('a'), mouthOh + eyes + nose + mouthHappy],
    'devil': ['(6)', '>' + eyes + nose + mouthHappy],

    'surprised-face': [eyes + nose + mouthOh],
    'straight-mouth': [eyes + nose + '|'],
    'straight-eyes-mouth': ['=|'],

    'kiss-face-heart': [eyes + nose + '*'],
    'kiss-face': [eyes + nose + '[Xx]'],
    'tongue-out': [eyes + nose + '&'],

    'derp': [eyes + nose + '[Pp]'],
    'dizzy-eyes': ['%' + nose + mouthOh],
    'sick-face': [eyes + nose + '@'],

    'grimace': [eyes + nose + 'E', eyes + nose + 'F'],
    'party': ['<' + eyes + nose + mouthOh, '<' + eyes + nose + mouthHappy],
    'zipper-mouth': [eyes + nose + '#'],

    'thinking-hand': [eyes + nose + '[Ll]'],
    'confused': [eyes + nose + '[Ss]'],
    'sarcastic-face': [';' + nose + '|'],

    'monocle': ['9' + nose + '|', '8' + nose + '|'],
    'thumbs-down': [lib('n')],
    'thumbs-up': [lib('y')],

    'beer': [lib('b')],
    'coffee-cup': [lib('c')],
    'lips': [lib('k')],

    'heart': [lib('l'), '<3'],
    'broken-heart': ['</3'],
    'lightbulb': [lib('i')],
    'present': [lib('g')],
};

const expand = (expr: string) => {
    let results = [expr];
    while (true) {
        const m = results[0].match(/\[(.*?)\]\??/);
        if (!m) break;
        const tokens = Array.from(m[1]);
        if (m[0].endsWith('?')) tokens.push('');
        results = tokens.flatMap(t => results.map(r => r.replace(/\[.*?\]\??/, t)));
    }
    return results.map(x => x.replace(/£/g, ']').replace(/€/g, '['));
};

const index = {} as Record<string, string>;
const xedni = {} as Record<string, string>;

for (const [name, exprs] of Object.entries(emoticons)) {
    for (const key of exprs.flatMap(expand)) {
        index[key] = name;
        if (name in xedni) continue;
        xedni[name] = key;
    }
}

export const Emoticon = {
    list() {
        return Object.keys(emoticons);
    },
    lookup(value: string) {
        if (!value) return null;
        if (value in emoticons) {
            return value;
        }
        return this.lookup(index[value] ?? null);
    },
    rlookup(name: string) {
        return xedni[name] ?? null;
    }
};
